import { render, staticRenderFns } from "./icare_modal_photo.vue?vue&type=template&id=d070077e&"
import script from "./icare_modal_photo.vue?vue&type=script&lang=js&"
export * from "./icare_modal_photo.vue?vue&type=script&lang=js&"
import style0 from "./icare_modal_photo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports